// One in-flight request, increasing intervals, and no background-tab traffic.
export function createVisiblePoller(task, env = {}) {
  const doc = env.document || document;
  const online = env.window || window;
  const later = env.setTimeout || setTimeout;
  const cancel = env.clearTimeout || clearTimeout;
  let timer = null, running = false, stopped = false, wanted = false, count = 0;
  const clear = () => { if (timer !== null) cancel(timer); timer = null };
  const visible = () => !doc.hidden && online.navigator.onLine !== false;
  const schedule = () => {
    clear();
    if (!stopped && wanted && visible()) timer = later(run, Math.min(60000, 5000 * Math.pow(2, Math.min(count, 4))));
  };
  async function run() {
    clear();
    if (stopped || running || !wanted || !visible()) return;
    running = true;
    try { const again = await task(); if (!stopped) wanted = again === true }
    catch (_) { /* The view displays errors; retry with backoff. */ }
    finally { running = false; count++; schedule() }
  }
  const resume = () => { clear(); if (visible() && wanted) run() };
  doc.addEventListener('visibilitychange', resume);
  online.addEventListener('online', resume);
  online.addEventListener('offline', clear);
  return {
    start() { if (stopped) return; wanted = true; count = 0; run() },
    pause() { wanted = false; clear() },
    stop() { stopped = true; wanted = false; clear(); doc.removeEventListener('visibilitychange', resume); online.removeEventListener('online', resume); online.removeEventListener('offline', clear) },
  };
}
